// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* Ahora agarra directamente de App.css para evitar errores con dark-mode */
}

/* SPINNER */
.spinner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(2px);
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 9999;
}

body.dark-mode .spinner {
    background-color: rgba(0, 0, 0, 0.6);
}

.spinner p {
    margin-top: 16px;
    font-size: 1.2rem;
    color: var(--primary-blue);
    font-weight: 500;
}

/* CUERPO DE LA PÁGINA (BODY) */

.column-layout {
    display: grid;
    grid-template-columns: 3fr 1.5fr;
    gap: 5rem; 
    padding: 30px 80px; 
    max-width: 1600px;
    margin: 0 auto;
}

.col-izquierda {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.col-derecha {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

/* Perfil y Contacto */
.info-card {
    background-color: var(--bg-card); 
    padding: 30px; 
    border-radius: 12px;
    border: 1px solid var(--color-borders); 
    box-shadow: var(--sombra-card);
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

.info-card-title {
    color: var(--primary-blue);
    font-size: 1.1em;
    font-weight: 600;
    margin-bottom: 25px;
    border-bottom: 1px solid var(--color-borders); 
    padding-bottom: 15px;
}

/* Grilla de Perfil */
.profile-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); 
    gap: 30px 40px; 
}

.profile-item {
    display: flex;
    align-items: flex-start; 
    gap: 15px;
    overflow: hidden; 
}

.profile-icon-wrapper {
    color: var(--primary-blue);
    font-size: 1.5em;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0; 
    margin-top: 3px; 
}

.profile-text-group {
    display: flex;
    flex-direction: column;
    line-height: 1.5;
    min-width: 0; 
    flex: 1 1;
}

.profile-title {
    font-size: 0.9em;
    color: var(--color-gray-text);
    margin: 0;
    font-weight: 500;
}

.profile-value {
    font-size: 1.1em;
    color: var(--texto-principal);
    margin-top: 2px;
    margin-bottom: 0;
    font-weight: 500;
    word-break: break-word; 
    overflow-wrap: break-word;
}

/* Estado de Seguros */
.seguros-subtitle {
    font-size: 0.9em;
    color: var(--color-gray-text);
    margin-bottom: 15px;
}

/* Estilos dinamicos de los tags de Polizas */
.seguros-tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
}

.seguro-tag--inactive {
    background-color: var(--color-light-bg); 
    border: 1px solid var(--color-borders);  
    color: var(--color-gray-text);          
    font-weight: 400;
}

.seguro-tag--inactive svg {
    color: var(--color-gray-text);
    fill: currentColor;
}

.seguro-tag--active {
    background-color: rgba(47, 168, 111, 0.1); 
    border: 1px solid var(--score-verde);
    color: var(--score-verde);
    font-weight: 600;
}

.seguro-tag {
    width: auto;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.85em;
    transition: all 0.2s;
}

/* Antiguedad */
.seguros-antiguedad {
    font-size: 0.9em;
    color: var(--color-gray-text);
    margin-bottom: 20px;
    font-weight: 400;
    padding-top: 15px;
    border-top: 1px solid var(--color-borders); 
}

.seguros-antiguedad strong {
    font-weight: 600;
    color: var(--texto-principal);
}

/* Metricas */
.seguros-metrics-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    text-align: center;
    padding-top: 15px;
    border-top: 1px solid var(--color-borders); 
}

.metric-value {
    font-size: 1.5em;
    font-weight: 700;
    color: var(--texto-principal);
    margin-bottom: 5px;
}

.metric-label {
    font-size: 0.8em;
    color: var(--color-gray-text);
    margin: 0;
}

.error-value {
    color: var(--score-rojo);
}

/* Coberturas */
.polizas-detalle-list {
    margin-top: 15px;
    border-top: 1px solid var(--color-borders); 
}

.polizas-detalle-list h4 {
    font-size: 0.9em;
    color: var(--color-gray-text);
    margin-bottom: 15px;
    font-weight: 400;
    margin-top: 15px;
}

.poliza-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    border-radius: 12px;
    background: var(--bg-input); 
    border: 1px solid var(--color-borders);
    margin-bottom: 10px;
    transition: all .2s ease;
}

.poliza-item:hover {
    background: var(--color-light-bg); 
    border-color: var(--primary-blue);
}

.poliza-chip {
    padding: 4px 10px;
    font-size: 0.8em;
    border-radius: 20px;
    font-weight: 600;
    background: rgba(80, 56, 237, 0.1);
    color: var(--primary-blue);
    border: 1px solid var(--primary-blue);
    margin-right: 15px;
}

.poliza-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 0.85em;
    color: var(--texto-principal);
}

.poliza-info strong {
    color: var(--texto-principal);
    font-weight: 600;
}

/* Interacciones */
.interaccion-text p {
    margin: 0;
}

.interaccion-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid transparent;
}

.interaccion-item:not(:last-child) {
    border-bottom: 1px solid var(--color-light-bg); 
}

.interaccion-icon {
    color: var(--primary-blue);
    font-size: 1.2em;
    margin-top: 2px;
}

.interaccion-text {
    font-size: 0.95em;
    color: var(--texto-principal);
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: start;
}

.interaccion-type {
    font-weight: 600;
    color: var(--primary-blue);
    margin-right: 5px;
}

.interaccion-date {
    font-size: 0.8em;
    color: var(--color-gray-text);
    margin-top: 3px;
}

/* Score Card */
.score-card {
    background-color: var(--bg-card); 
    padding: 25px;
    border-radius: 12px;
    box-shadow: var(--sombra-card);
    border: 1px solid var(--color-borders); 
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    gap: 15px;
}

.score-title {
    font-size: 1.5em;
    font-weight: 600;
    margin: 0;
    width: 100%;
    border: none;
    padding: 0;
    color: var(--texto-principal);
}

.score-bar-container {
    width: 90%;
    height: 15px;
    background-color: var(--color-light-bg); 
    border-radius: 10px;
    margin: 0;
    overflow: hidden;
}

.score-bar-fill {
    height: 100%;
    transition: width 0.5s ease-out;
}

.score-value-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}

.score-value {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0;
    color: var(--texto-principal);
}

.score-rango {
    padding: 8px 20px;
    border-radius: 20px;
    font-size: 1rem;
    font-weight: 700;
    color: white; 
    margin: 0;
}

.score-message {
    font-size: 1.3em;
    margin: 0;
    color: #000000; 
    font-weight: 500;
    text-align: center;
    width: 100%; 
}

.recommended-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.recommended-card .seguros-tags {
    justify-content: center;
}

.email-button {
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 50px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s;
    box-shadow: var(--sombra-card);
    max-width: 300px;
    font-size: 1.3rem;
    font-family: var(--font-principal);
}

.email-button:hover {
    filter: brightness(110%);
}


/* Media Queries */
@media (max-width: 1200px) {
    .column-layout {
        grid-template-columns: 1fr; 
        gap: 2rem;
        padding: 20px 40px; 
    }
    
    .col-derecha {
        flex-direction: row; 
        flex-wrap: wrap;
        justify-content: center;
    }
    
    .score-card {
        max-width: 500px;
    }
}

@media (max-width: 768px) {
    .column-layout {
        padding: 20px 20px; 
    }

    .profile-grid {
        grid-template-columns: 1fr; 
    }
    
    .seguros-metrics-grid {
        grid-template-columns: repeat(2, 1fr); 
    }
    
    .col-derecha {
        flex-direction: column;
    }
}

.btn-view-interaction {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    color: var(--color-gray-text);
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
}

.btn-view-interaction:hover {
    background-color: rgba(80, 56, 237, 0.1);
    color: var(--primary-blue);
}

.btn-view-interaction svg {
    font-size: 1.1rem;
}

.interaccion-item {
    width: 100%; 
}

.interaccion-text {
    flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/DetalleCliente/detalleCliente.css"],"names":[],"mappings":"AAAA;IACI,2EAA2E;AAC/E;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,+BAA+B;;AAE/B;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,8BAA8B;IAC9B,8DAA8D;AAClE;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,sCAAsC;IACtC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,aAAa;AACb;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,eAAe;AACf;IACI,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,sCAAsC;IACtC,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;IAClC,0BAA0B;IAC1B,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,eAAe;AACf;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA,kBAAkB;AAClB;IACI;QACI,0BAA0B;QAC1B,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAO;AACX","sourcesContent":[":root {\r\n    /* Ahora agarra directamente de App.css para evitar errores con dark-mode */\r\n}\r\n\r\n/* SPINNER */\r\n.spinner {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    backdrop-filter: blur(2px);\r\n    background-color: rgba(255, 255, 255, 0.6);\r\n    z-index: 9999;\r\n}\r\n\r\nbody.dark-mode .spinner {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.spinner p {\r\n    margin-top: 16px;\r\n    font-size: 1.2rem;\r\n    color: var(--primary-blue);\r\n    font-weight: 500;\r\n}\r\n\r\n/* CUERPO DE LA PÁGINA (BODY) */\r\n\r\n.column-layout {\r\n    display: grid;\r\n    grid-template-columns: 3fr 1.5fr;\r\n    gap: 5rem; \r\n    padding: 30px 80px; \r\n    max-width: 1600px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.col-izquierda {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 30px;\r\n}\r\n\r\n.col-derecha {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    align-items: center;\r\n}\r\n\r\n/* Perfil y Contacto */\r\n.info-card {\r\n    background-color: var(--bg-card); \r\n    padding: 30px; \r\n    border-radius: 12px;\r\n    border: 1px solid var(--color-borders); \r\n    box-shadow: var(--sombra-card);\r\n    transition: background-color 0.3s ease, border-color 0.3s ease;\r\n}\r\n\r\n.info-card-title {\r\n    color: var(--primary-blue);\r\n    font-size: 1.1em;\r\n    font-weight: 600;\r\n    margin-bottom: 25px;\r\n    border-bottom: 1px solid var(--color-borders); \r\n    padding-bottom: 15px;\r\n}\r\n\r\n/* Grilla de Perfil */\r\n.profile-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr); \r\n    gap: 30px 40px; \r\n}\r\n\r\n.profile-item {\r\n    display: flex;\r\n    align-items: flex-start; \r\n    gap: 15px;\r\n    overflow: hidden; \r\n}\r\n\r\n.profile-icon-wrapper {\r\n    color: var(--primary-blue);\r\n    font-size: 1.5em;\r\n    width: 25px;\r\n    height: 25px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-shrink: 0; \r\n    margin-top: 3px; \r\n}\r\n\r\n.profile-text-group {\r\n    display: flex;\r\n    flex-direction: column;\r\n    line-height: 1.5;\r\n    min-width: 0; \r\n    flex: 1;\r\n}\r\n\r\n.profile-title {\r\n    font-size: 0.9em;\r\n    color: var(--color-gray-text);\r\n    margin: 0;\r\n    font-weight: 500;\r\n}\r\n\r\n.profile-value {\r\n    font-size: 1.1em;\r\n    color: var(--texto-principal);\r\n    margin-top: 2px;\r\n    margin-bottom: 0;\r\n    font-weight: 500;\r\n    word-break: break-word; \r\n    overflow-wrap: break-word;\r\n}\r\n\r\n/* Estado de Seguros */\r\n.seguros-subtitle {\r\n    font-size: 0.9em;\r\n    color: var(--color-gray-text);\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* Estilos dinamicos de los tags de Polizas */\r\n.seguros-tags {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.seguro-tag--inactive {\r\n    background-color: var(--color-light-bg); \r\n    border: 1px solid var(--color-borders);  \r\n    color: var(--color-gray-text);          \r\n    font-weight: 400;\r\n}\r\n\r\n.seguro-tag--inactive svg {\r\n    color: var(--color-gray-text);\r\n    fill: currentColor;\r\n}\r\n\r\n.seguro-tag--active {\r\n    background-color: rgba(47, 168, 111, 0.1); \r\n    border: 1px solid var(--score-verde);\r\n    color: var(--score-verde);\r\n    font-weight: 600;\r\n}\r\n\r\n.seguro-tag {\r\n    width: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 5px 12px;\r\n    border-radius: 20px;\r\n    font-size: 0.85em;\r\n    transition: all 0.2s;\r\n}\r\n\r\n/* Antiguedad */\r\n.seguros-antiguedad {\r\n    font-size: 0.9em;\r\n    color: var(--color-gray-text);\r\n    margin-bottom: 20px;\r\n    font-weight: 400;\r\n    padding-top: 15px;\r\n    border-top: 1px solid var(--color-borders); \r\n}\r\n\r\n.seguros-antiguedad strong {\r\n    font-weight: 600;\r\n    color: var(--texto-principal);\r\n}\r\n\r\n/* Metricas */\r\n.seguros-metrics-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap: 20px;\r\n    text-align: center;\r\n    padding-top: 15px;\r\n    border-top: 1px solid var(--color-borders); \r\n}\r\n\r\n.metric-value {\r\n    font-size: 1.5em;\r\n    font-weight: 700;\r\n    color: var(--texto-principal);\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.metric-label {\r\n    font-size: 0.8em;\r\n    color: var(--color-gray-text);\r\n    margin: 0;\r\n}\r\n\r\n.error-value {\r\n    color: var(--score-rojo);\r\n}\r\n\r\n/* Coberturas */\r\n.polizas-detalle-list {\r\n    margin-top: 15px;\r\n    border-top: 1px solid var(--color-borders); \r\n}\r\n\r\n.polizas-detalle-list h4 {\r\n    font-size: 0.9em;\r\n    color: var(--color-gray-text);\r\n    margin-bottom: 15px;\r\n    font-weight: 400;\r\n    margin-top: 15px;\r\n}\r\n\r\n.poliza-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 12px 14px;\r\n    border-radius: 12px;\r\n    background: var(--bg-input); \r\n    border: 1px solid var(--color-borders);\r\n    margin-bottom: 10px;\r\n    transition: all .2s ease;\r\n}\r\n\r\n.poliza-item:hover {\r\n    background: var(--color-light-bg); \r\n    border-color: var(--primary-blue);\r\n}\r\n\r\n.poliza-chip {\r\n    padding: 4px 10px;\r\n    font-size: 0.8em;\r\n    border-radius: 20px;\r\n    font-weight: 600;\r\n    background: rgba(80, 56, 237, 0.1);\r\n    color: var(--primary-blue);\r\n    border: 1px solid var(--primary-blue);\r\n    margin-right: 15px;\r\n}\r\n\r\n.poliza-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n    font-size: 0.85em;\r\n    color: var(--texto-principal);\r\n}\r\n\r\n.poliza-info strong {\r\n    color: var(--texto-principal);\r\n    font-weight: 600;\r\n}\r\n\r\n/* Interacciones */\r\n.interaccion-text p {\r\n    margin: 0;\r\n}\r\n\r\n.interaccion-item {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    padding: 10px 0;\r\n    border-bottom: 1px solid transparent;\r\n}\r\n\r\n.interaccion-item:not(:last-child) {\r\n    border-bottom: 1px solid var(--color-light-bg); \r\n}\r\n\r\n.interaccion-icon {\r\n    color: var(--primary-blue);\r\n    font-size: 1.2em;\r\n    margin-top: 2px;\r\n}\r\n\r\n.interaccion-text {\r\n    font-size: 0.95em;\r\n    color: var(--texto-principal);\r\n    margin: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n}\r\n\r\n.interaccion-type {\r\n    font-weight: 600;\r\n    color: var(--primary-blue);\r\n    margin-right: 5px;\r\n}\r\n\r\n.interaccion-date {\r\n    font-size: 0.8em;\r\n    color: var(--color-gray-text);\r\n    margin-top: 3px;\r\n}\r\n\r\n/* Score Card */\r\n.score-card {\r\n    background-color: var(--bg-card); \r\n    padding: 25px;\r\n    border-radius: 12px;\r\n    box-shadow: var(--sombra-card);\r\n    border: 1px solid var(--color-borders); \r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n    width: 100%;\r\n    gap: 15px;\r\n}\r\n\r\n.score-title {\r\n    font-size: 1.5em;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    width: 100%;\r\n    border: none;\r\n    padding: 0;\r\n    color: var(--texto-principal);\r\n}\r\n\r\n.score-bar-container {\r\n    width: 90%;\r\n    height: 15px;\r\n    background-color: var(--color-light-bg); \r\n    border-radius: 10px;\r\n    margin: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.score-bar-fill {\r\n    height: 100%;\r\n    transition: width 0.5s ease-out;\r\n}\r\n\r\n.score-value-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.score-value {\r\n    font-size: 2.5rem;\r\n    font-weight: 700;\r\n    margin: 0;\r\n    color: var(--texto-principal);\r\n}\r\n\r\n.score-rango {\r\n    padding: 8px 20px;\r\n    border-radius: 20px;\r\n    font-size: 1rem;\r\n    font-weight: 700;\r\n    color: white; \r\n    margin: 0;\r\n}\r\n\r\n.score-message {\r\n    font-size: 1.3em;\r\n    margin: 0;\r\n    color: #000000; \r\n    font-weight: 500;\r\n    text-align: center;\r\n    width: 100%; \r\n}\r\n\r\n.recommended-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n\r\n.recommended-card .seguros-tags {\r\n    justify-content: center;\r\n}\r\n\r\n.email-button {\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    border-radius: 50px;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    transition: background-color 0.2s;\r\n    box-shadow: var(--sombra-card);\r\n    max-width: 300px;\r\n    font-size: 1.3rem;\r\n    font-family: var(--font-principal);\r\n}\r\n\r\n.email-button:hover {\r\n    filter: brightness(110%);\r\n}\r\n\r\n\r\n/* Media Queries */\r\n@media (max-width: 1200px) {\r\n    .column-layout {\r\n        grid-template-columns: 1fr; \r\n        gap: 2rem;\r\n        padding: 20px 40px; \r\n    }\r\n    \r\n    .col-derecha {\r\n        flex-direction: row; \r\n        flex-wrap: wrap;\r\n        justify-content: center;\r\n    }\r\n    \r\n    .score-card {\r\n        max-width: 500px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .column-layout {\r\n        padding: 20px 20px; \r\n    }\r\n\r\n    .profile-grid {\r\n        grid-template-columns: 1fr; \r\n    }\r\n    \r\n    .seguros-metrics-grid {\r\n        grid-template-columns: repeat(2, 1fr); \r\n    }\r\n    \r\n    .col-derecha {\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.btn-view-interaction {\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 8px;\r\n    border-radius: 50%;\r\n    color: var(--color-gray-text);\r\n    transition: all 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-left: auto;\r\n}\r\n\r\n.btn-view-interaction:hover {\r\n    background-color: rgba(80, 56, 237, 0.1);\r\n    color: var(--primary-blue);\r\n}\r\n\r\n.btn-view-interaction svg {\r\n    font-size: 1.1rem;\r\n}\r\n\r\n.interaccion-item {\r\n    width: 100%; \r\n}\r\n\r\n.interaccion-text {\r\n    flex: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
